export default 'Privacy Policy'
